<template>
    <div id="System_Site">
        <el-card class="box-card">
            <el-form ref="form" :model="form"
                     :label-width="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'100px':'300px'"
                     size="small">

                  
                <el-form-item  label="国家选项：">
                    <el-select v-model="value" placeholder="请选择"
                            :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':''" @change="selectWorkName">
                        <el-option label="默认中国" value="nicorn_CN"></el-option>
                        <el-option label="菲律宾" value="nicorn_PH"></el-option>
                        <el-option label="泰国" value="nicorn_TH"></el-option>
                        <el-option label="印度尼西亚" value="nicorn_ID"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="充值金额："
                              :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'">
                    <el-select
                            v-model="form.charge_money"
                            multiple
                            filterable
                            allow-create
                            default-first-option
                            placeholder="请选择金额"
                            :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'">
                        <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="充值比率：" 
                        :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'">
                    <el-select
                            v-model="form.get_money"
                            multiple
                            filterable
                            allow-create
                            default-first-option
                            placeholder="选择充值比率："
                            :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'">
                        <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="支付商品ID："
                              :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'">
                    <el-select
                            v-model="form.charge_id"
                            multiple
                            filterable
                            allow-create
                            default-first-option
                            placeholder="支付商品ID"
                            :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'">
                        <el-option
                                v-for="item in form.coinesc"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>


                <el-form-item label="充值赠送比例："
                              :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'">
                    <el-select
                            v-model="form.get_handsel"
                            multiple
                            filterable
                            allow-create
                            default-first-option
                            placeholder="充值赠送比例"
                            :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'">
                        <el-option
                                v-for="item in form.coinesc"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                  <el-form-item :label="'支付说明'" :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'">
                    <el-select
                            v-model="form.paytips"
                            multiple
                            filterable
                            allow-create
                            default-first-option
                            :placeholder="'请填写支付说明'"
                            :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'">
                    </el-select>
                </el-form-item>

                <el-form-item :label="this.$store.state.name+'说明：'" :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'">
                    <el-select
                            v-model="form.coinesc"
                            multiple
                            filterable
                            allow-create
                            default-first-option
                            :placeholder="'请填写'+this.$store.state.name+'说明'"
                            :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'">
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">保存</el-button>
                </el-form-item>
            
            </el-form>
        </el-card>
    </div>
</template>

<script>
    export default {
        name: "system_site",
        data() {
            return {
                value:'',
                form: {
                    type:'', 
                    coinesc: '',
                    paytips: '',
                    charge_money: '',
                    charge_id:'',
                    get_handsel:'',
                    get_money: '',

                },
                options: [{
                    value: '1',
                    label: '1'
                }, {
                    value: '3',
                    label: '3'
                }, {
                    value: '5',
                    label: '5'
                }],
            }
        },
        created() {
            this.getData()
        },
        methods: {
            selectWorkName(val){
                this.form.charge_money = this.form.charge_money.join(',');
                this.$axios.post('admin/config/paynicorn',{"type":val}).then((res) => {
                    this.form = res.data;
                    if (this.form.charge_money == '') {
                        this.form.charge_money = [];
                    } else {
                        this.form.charge_money = this.form.charge_money.split(",")
                    }
                });
            },
            onSubmit() {
                this.form.charge_money = this.form.charge_money.join(',');
                this.$axios.post('admin/config/paynicorn_set', {config: this.form}).then((res) => {
                    this.$message.success('成功');
                    this.getData();

                });
            },
            getData(){

            }
        }
    }
</script>

<style scoped>

</style>